import { Card, CardProps } from "@mui/material";
import { SxProps } from "@mui/system";

const StyledCard: React.FC<CardProps> = ({ children, sx, ...props }) => {
  return (
    <Card
      sx={{
        border: "1px solid #BCA685",
        borderRadius: "5px",
        padding: "10px",
        boxShadow: "none",
        ...(sx as SxProps),
      }}
      {...props}
    >
      {children}
    </Card>
  );
};

export default StyledCard;
